export const ASSET_TYPE_IMAGE = 'image';
export const ASSET_TYPE_LIBRARY_IMAGE = 'library_image';
export const ASSET_TYPE_BACKGROUND = 'background';
export const ASSET_TYPE_LARGE_BACKGROUND = 'large_background';
export const ASSET_TYPE_MOBILE_BACKGROUND = 'mobile_background';

export const ASSET_TYPE_HEADER_LOGO = 'header_logo';
export const ASSET_TYPE_FOOTER_LOGO = 'footer_logo';
export const ASSET_TYPE_VIDEO = 'video';
export const ASSET_TYPE_LINK = 'link';
export const ASSET_TYPE_DOCUMENT = 'document';
export const ASSET_TYPE_AUDIO = 'audio';
export const ASSET_TYPE_HOTSPOT_BACKGROUND = 'hotspot_background';
export const ASSET_SUB_TYPE_MP4 = 'mp4';
export const ASSET_SUB_TYPE_YOUTUBE = 'youtube';
export const ASSET_SUB_TYPE_VIMEO = 'vimeo';
export const ASSET_TYPE_ID_CHARACTER_FULL_BODY = 'character_full_body';
export const ASSET_TYPE_ID_CHARACTER_FULL_BODY_LARGER = 'character_full_body_larger';
export const ASSET_TYPE_ID_CHARACTER_HALF_BODY = 'character_half_body';
export const ASSET_TYPE_ID_CHARACTER_PROFILE = 'character_profile';
export const ASSET_TYPE_ID_LOGO = 'logo';
export const ASSET_TYPE_ID_MENU_THUMBNAIL = 'menu_thumbnail';
export const ASSET_TYPE_ICON = 'icon';
export const ASSET_TYPE_ID_CHARACTER = 'character';
export const ASSET_TYPE_METRIC_RESULT = 'metric_result';


export const ASSET_TYPE_SELECTED = 'selected';
export const ASSET_TYPE_INHERIT_FROM_THEME = 'from_theme';

export const ASSET_AUDIO = 'asset_audio';
export const ASSET_CHILD_AUDIO = 'asset_child_audio';
export const ASSET_CHILD_AUDIO_OPTION = 'asset_child_audio_option';

export const ASSET_TYPE_EARNED = 'earned';
export const ASSET_TYPE_UNEARNED = 'unearned';


/** WEBPACK FOOTER **
 ** ./src/constants/assetConstants.js
 **/